export default import.meta.ROLLDOWN_FILE_URL_eDtTcVQ1c26A0AX1IhNTOg